var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"select"}},_vm._l((_vm.testDate),function(item,index){return _c('ul',{key:index},[_c('li',[_c('a',{attrs:{"href":""}},[_vm._v(_vm._s(item.name))])])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }